/**
 * Early image / shell reveal — runs before the full theme.js bundle.
 * Images use class "is-loading" (opacity ~0) until this clears it.
 * Keeping this separate lets homepage delay vendor.js + theme.js without blank media.
 */
(function () {
  var LOADING = 'is-loading';

  function uncover(img) {
    if (!img || !img.classList || !img.classList.contains(LOADING)) return;
    img.classList.remove(LOADING);
    if (img.parentNode && img.parentNode.classList) {
      img.parentNode.classList.remove(LOADING);
    }
    if (
      img.parentNode &&
      img.parentNode.parentNode &&
      img.parentNode.parentNode.classList
    ) {
      img.parentNode.parentNode.classList.remove(LOADING);
    }
  }

  document.addEventListener(
    'load',
    function (e) {
      if (e.target && e.target.tagName === 'IMG') uncover(e.target);
    },
    true
  );

  function boot() {
    document.querySelectorAll('img.' + LOADING).forEach(function (img) {
      if (img.complete) uncover(img);
    });
    if (document.body) {
      document.body.classList.add('is-loaded');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
